import { PageHeader } from "../components/PageHeader";
import { Reveal, MaskLinesInView } from "../components/Reveal";
import { ArrowButton } from "../components/Buttons";
import { PILLARS } from "../data/site";

const WhyTara = () => (
  <div data-testid="why-tara-page">
    <PageHeader
      label="Why Tara"
      lines={["Why work", "with us?"]}
      intro="We combine strategic thinking with creative excellence — and a way of working built entirely around your growth."
      dark
    />

    <section className="bg-bottle-green text-cream pb-24 md:pb-32">
      <div className="max-w-[1500px] mx-auto px-5 md:px-10">
        <div className="border-t border-cream/15">
          {PILLARS.map((p, i) => (
            <Reveal key={p.num} delay={i * 0.05}>
              <div className="group grid md:grid-cols-12 gap-6 md:gap-10 py-10 md:py-14 border-b border-cream/15 items-start hover:pl-2 transition-all duration-500">
                <span className="md:col-span-2 font-mono text-sm text-cream/45">{p.num}</span>
                <h2 className="md:col-span-5 font-serif text-3xl md:text-5xl tracking-tight leading-[0.95]">{p.title}</h2>
                <p className="md:col-span-5 font-sans text-base md:text-lg text-cream/65 leading-relaxed md:pt-2">{p.text}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>

    {/* Manifesto close */}
    <section className="bg-cream py-24 md:py-40 text-center">
      <div className="max-w-[1500px] mx-auto px-5 md:px-10">
        <Reveal><span className="label text-dark-text/50">Our promise</span></Reveal>
        <MaskLinesInView
          lines={["Think with purpose.", "Create with intention.", "Deliver with impact."]}
          className="block mt-8"
          lineClass="font-serif text-4xl md:text-6xl lg:text-7xl tracking-tight leading-[0.98] text-dark-text"
        />
        <Reveal delay={0.4} className="mt-14 flex justify-center">
          <ArrowButton to="/contact" testid="why-tara-work-together">Let's Work Together</ArrowButton>
        </Reveal>
      </div>
    </section>
  </div>
);

export default WhyTara;
